import { lazy } from "react";

const HomePage = lazy(() => import("./ui/HomePage"));

export { HomePage };
